/**
 * Allgemeiner Bestätigungsdialog statt window.confirm — nutzt das App-Dialog-System (SystemDialogService)
 * mit dem Template #bestaetigen-dialog aus Dienstplaner.html. Liegt per z-index über den eigenen
 * Dialogen (Bedarf, Event-Editor), die also beim Nachfragen offen bleiben.
 */

import SystemDialogService from '../../../../shared/services/systemDialogService.js';

/**
 * Fragt den Nutzer nach einer Bestätigung.
 * @param {object} optionen
 * @param {string} optionen.titel Frage als Überschrift, z.B. "Event löschen?"
 * @param {string} [optionen.text] Erläuterung darunter (Zeilenumbrüche mit \n erlaubt)
 * @param {string} [optionen.okText] Beschriftung des Bestätigen-Buttons
 * @param {string} [optionen.abbrechenText] Beschriftung des Abbrechen-Buttons
 * @returns {Promise<boolean>} true bei Bestätigung, false bei Abbrechen/Escape/Klick daneben
 */
async function bestaetige({ titel, text = '', okText = 'Ja', abbrechenText = 'Abbrechen' }) {
	const dialog = document.getElementById('bestaetigen-dialog');
	dialog.querySelector('.nachricht-titel').textContent = titel;
	dialog.querySelector('.nachricht-info').textContent = text;
	dialog.querySelector('.bestaetigen-ok').textContent = okText;
	dialog.querySelector('.bestaetigen-abbrechen').textContent = abbrechenText;
	const ergebnis = await SystemDialogService.instance.displayAsync('bestaetigen-dialog');
	return ergebnis?.success === true;
}

/** Ist gerade ein App-Dialog (z.B. eine Bestätigung) offen? Für Escape-Handler der eigenen Dialoge. */
function istAppDialogOffen() {
	return document.getElementById(SystemDialogService.popupID)?.classList.contains('visible') ?? false;
}

export { bestaetige, istAppDialogOffen };
